module.exports = __webpack_public_path__ + "static/img/logo.f4ea16c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 1075
// module chunks = 1